import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiMfaSelectcredentialMutationRequest,
  PostApiMfaSelectcredentialMutationResponse,
  PostApiMfaSelectcredential401,
  PostApiMfaSelectcredential403,
} from "../../../types/PostApiMfaSelectcredential";

export function getPostApiMfaSelectcredentialUrl() {
  return `/api/MFA/SelectCredential` as const;
}

/**
 * {@link /api/MFA/SelectCredential}
 */
export async function postApiMfaSelectcredential(
  data?: PostApiMfaSelectcredentialMutationRequest,
  config: Partial<RequestConfig<PostApiMfaSelectcredentialMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiMfaSelectcredentialMutationResponse,
    ResponseErrorConfig<
      PostApiMfaSelectcredential401 | PostApiMfaSelectcredential403
    >,
    PostApiMfaSelectcredentialMutationRequest
  >({
    method: "POST",
    url: getPostApiMfaSelectcredentialUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
